// ======================================================
// HEAREN USER STEPS V1
// Simple usage maturity model
// ======================================================

export const HEAREN_USER_STEPS = {
  DISCOVERY: {
    step: 1,
    id: 'discovery',
  },

  FIRST_EXPERIENCE: {
    step: 2,
    id: 'first_experience',
  },

  ENGAGED: {
    step: 3,
    id: 'engaged',
  },

  REGULAR: {
    step: 4,
    id: 'regular',
  },

  EXPERIENCED: {
    step: 5,
    id: 'experienced',
  },
};

export const resolveHearenUserStep = (signals = {}) => {
  const {
    sessionsCount = 0,
    totalMinutes = 0,
    activeDays = 0,
  } = signals || {};

  if (totalMinutes >= 600 && activeDays >= 7) {
    return HEAREN_USER_STEPS.EXPERIENCED;
  }

  if (totalMinutes >= 120) {
    return HEAREN_USER_STEPS.REGULAR;
  }

  if (sessionsCount >= 3 || activeDays >= 2) {
    return HEAREN_USER_STEPS.ENGAGED;
  }

  if (sessionsCount >= 1 || totalMinutes >= 10) {
    return HEAREN_USER_STEPS.FIRST_EXPERIENCE;
  }

  return HEAREN_USER_STEPS.DISCOVERY;
};